module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "section-3"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("٤")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "17px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يمشي إيفان بقلقٍ وانتظارٍ حافي القدمَين في جواربه، يعيد برأسه أحداث اللحظة الأخيرة وصوتها، هل حقًّا استفاقت؟ أم ستعود إلى النوم؟ هل هذه صحوة الموت كما كان يسمع جدَّته تقصُّ خبر موت جدّه آلاف المرّات أمام الجميع وبالطريقة نفسها مِن دون تبديل أي حرف، لا زيادة ولا نقصان؟ كيف يمكنها ألّا تنسى أي حرف وكأنها تضغط على زر تشغيل المسجِّلة في كلّ مرّة؟! هل سيبدأ سرد قصَّته بأنَّه كان يحلم بالحادث عندما استعادت وعيها للحظات!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يعود إلى الواقع كأنَّه انتبهَ لأمرٍ طارئ، يأخذ هاتفه، يطلب رقمًا، وينتظر أن يأتيه الجواب، ورغم أنّه يسمعها تجيبه لكن الكلمات لا تخرج مِن فمه للحظات.. (لمى) عيناه بين الأمل والبكاء وعدم تصديق ما جرى.. ينقل لها كلَّ ما يحدث فتضحك محمرَّة العينين وهي تحمل الهاتف وتهزُّ رأسها.. لا تجيبه بالكلمات بل بالصّراخ والبكاء، وتشكره آلاف المرّات.. تنظر أمامها، فترى صحن السلَطة الصغير الذي تقوم بصنعه، وعلى الخشبة أمامها حبة بندورة واحدة مقطّعة، وعلى حوض المطبخ بعض الخضار وعلبة ذرة صغيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمَت للصحن بجنون وهي تمسح يديها بفوطة المطبخ بعجلةٍ، وتركض في أرجاء البيت وكأنَّها تقول له إنَّ العائلة ستعود، وأنَّ هذا الصحن المفرد الأخير. تأخذ حقيبتها، وتنطلق مسرعة وهي لا تزال في خفَّيها، فتعود لتفتح الباب، وتأخذ سكربينتها وترحل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الغرفة ما زالت مليئة بالأطبّاء، تالا تجلس هادئة في سريرها، ساقاها خارج السرير، ثياب المستشفى تصل إلى ركبتيها، أظافر رجلَيها نظيفة قصيرة وغير مطلية، تحاول تحريكها فلا تستطيع، تحوِّل نظرها من رجلَيها إلى الصور مِن دون أن تتكلّم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أصدقاء الدراسة، ووالدتها مع رجلٍ لَم تستطع أن تتعرَّف إليه، ولَم تفهم لِمَ يتصوَّر معها وحدهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تتأمَّل المحيطين بها، والأجهزة التي ما عادت متّصلة بها، ومِن ثم تعود بنظراتها إلى صورتها وهي نائمة وبقربها رجل مِن دون أي تعابير على وجهها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ الأطبّاء بالرحيل، وبقيَت معها ممرِّضة لحين دخول والدتها وإيفان.. تنظر إليهما ولكنها لا تُظهِر أي مشاعر، بينما تحاول لمى جاهدة إخفاء تأثُّرها، تقترب مِن سرير تالا بتمهُّلٍ فيما يبقى هو بعيدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("«تالا!» تريد أن تحضنها لكنَّ الفراغ في عينيها يربكها، تنظر نحو إيفان بقلق، تحاول إمساك يدها وتتردَّد، تلاحق تالا يدها بنظرها، وترتاح لأنَّها لَم تلمسها، تسألها إن كانت تعرف مَن تكون، وبعد صمتٍ ثقيل، تجيبها بصوت متقطِّع ولفظ بطيء أنَّها تشبه أمَّها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تستغرب تالا نضوج صوتها وبطأه فتصمت، أمَّا لمى فتبتسم والدموع في عينيها، وتشير إلى لون شعرها إلى أنَّها ستعيده كما كان لأجلها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تحاول الكلام لكنَّها لا تستطيع، بألمٍ تحاول رفع يدها إلى حنجرتها، تتابع لمى حركتها، وتتجرَّأ أخيرًا على إمساك يد تالا الملقاة على السرير، فتنتفض مِن دون أن تتمكَّن مِن سحب يدها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يجمع إيفان شجاعته، ويقترب قليلًا مِن السرير، فتنقل تالا نظرها إليه، تجهد نفسها لتسأله مَن هو، لا يعرف كيف يجيب، لا يعرف لماذا لَم يقل اسمه فقط:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما عرفتيني؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تشير بعينيها نحو الصور، فهذا كل ما يمثِّله بالنسبة إليها، تنظر لمى إليه وقد لاحظَت للمرَّة الأولى ملامح إيفان الثلاثينيَّة، وفهمَت كيف أنَّ تالا لَم تتعرَّف إليه، فهذا الرجل الناضج لَم يعد يشبه الفتى المتهوِّر بشيءٍ حتَّى بروحه، فتجيبها لمى بتروٍّ أنَّه إيفان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت تنظر نحوه مِن دون أي ملامح حبّ أو عاطفة، حتَّى سمعَت اسمه، حينها بدأ الخوف بالتَّسلُّل إليها، وراح يتصاعد مِن دون أن تستطيع السيطرة عليه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تسمع نفَسها وهي تصرخ، ولَم تعُد حيث كانت في السرير، هي في مكانٍ مظلم وموجع، مكان تريد الهرب منه، شعرَت كأنَّها في حلم وهي تركض، لكنَّها تراوح مكانها، هي في السيَّارة وشيء ما يشدُّها إلى الداخل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تدخل الممرِّضة مهرولةً بعد أن كانت قد سمعَت صراخها حتى مكتب الاستعلام في الطابق، تحاول معرفة سبب الأزمة، فتجيبها لمى بتوتّر وهي ما زالت تكبس على زر النداء مِن كثرة ذهولها بما حدث:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لمّا سمعت اسمه!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ينصاعان لطلب الممرِّضة حين طالبَتهما بالخروج.. خرج إيفان متأثِّرًا؛ لأنَّها لَم تتعرَّف إليه، شعر بأنَّه متروك ومتعلِّق بوهمٍ وفراغ، وخلفه لمى باكية تحضنه، ومِن ثم تبتعد عنه وتتكلَّم بعقلانيّة كأنها تُقنِع نفسها أيضًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما عِرفِتْنِي.. أنا مرحلةِ كِنتْ بحياتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقاطعه قبل أن تجرَّه الكآبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إيفان!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا بس بعرفها، ١٤ سنة أنا مرافقها.. هي ما بتعرفني، معها حقّ.. كلّكُنْ معكُنْ حقّ كان!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- بلا حكي بلا طعمة، واسمعني منيح وما تفهمني غلط.. يمكن هالفترة ما بقا لازم تجي لهون!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ينظر إليها غير مصدِّق لما قالَته كأنَّها طعنَته، طالبًا ألَّا تقصيه، ذكَّرها أنَّه لَم يتركها قبلًا وهي نائمة، وهو ليس مستعدًّا لأن يتركها الآن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تضع يدها على قلبه بتعاطف لتطمئنه بأنَّها لن تبعده، لكنَّهما لا يعرفان ماذا ستكون ردَّة فعلها تجاهه؛ فهي انهارت ما إن سمعَت بِاسْمه، وحين حاولَ إقناعها قاطعَته بحزمٍ وهي تحاول تذكيره كم حضَّرا لهذه اللحظة، وكم أجرَيا بحوثًا عليها! فيضع رأسه أرضًا مستسلمًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَت أن يذهب ويرتاح بعد ليلةٍ طويلة، وبغصَّةٍ أنهَت جملتها وهي تبتعد عنه، وتتناول علبة سجائرها مِن حقيبتها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- روح عِنْد مَرْتَك بتكون ناطِرْتَك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 84
// module chunks = 0